import { createHeadlessClient, type Environment } from '@tagadapay/headless-sdk';
import type { OfferSelection } from '../data/offers';

const variantEnv: Record<OfferSelection, string | undefined> = {
  1: import.meta.env.VITE_TAGADA_RT10_VARIANT_1,
  2: import.meta.env.VITE_TAGADA_RT10_VARIANT_2,
  3: import.meta.env.VITE_TAGADA_RT10_VARIANT_3,
  4: import.meta.env.VITE_TAGADA_RT10_VARIANT_BULK
};

const storeId = import.meta.env.VITE_TAGADA_STORE_ID as string | undefined;
const environment = (import.meta.env.VITE_TAGADA_ENVIRONMENT ?? 'production') as Environment;

export function useTagadaCheckoutSession() {
  async function createSession(selection: OfferSelection, bulkQty: number) {
    const variantId = variantEnv[selection];

    if (!storeId) {
      throw new Error('VITE_TAGADA_STORE_ID is not configured.');
    }

    if (!variantId) {
      throw new Error('Tagada variant ID is not configured for this allocation.');
    }

    const quantity = selection === 4 ? bulkQty : 1;
    const client = createHeadlessClient({ storeId, environment });

    return client.checkout.createSession({
      items: [{ variantId, quantity }],
      currency: 'USD',
      returnUrl: `${window.location.origin}/checkout`
    });
  }

  return { createSession };
}

export function tagadaCheckoutConfigured(selection: OfferSelection) {
  return Boolean(storeId && variantEnv[selection]);
}
